import { useState } from "react";
import "../../styles/AddTutorFlow.css";
import Call_Api from "../../Common/Handileapi/Call_api";
import { path } from "../../routes/Paths";
import Cookies from "js-cookie";
import { checkCompareNames } from "../../Common/creditCardBinAPI/CommonFunctions";
import { useNavigate } from "react-router-dom";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import Header from "../../components/Header/Header.js";
import EducationPay from "./cardUserScreen";

const verificationConfig = {
  Mobile: {
    label: "Mobile Number",
    placeholder: "Enter 10-digit mobile number",
    regex: /^[6-9]\d{9}$/,
    errorMessage: "Please enter a valid 10-digit mobile number.",
  },

  Pan: {
    label: "PAN Number",
    placeholder: "Enter PAN number (ABCDE1234F)",
    regex: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
    errorMessage: "Please enter a valid PAN number (Example: ABCDE1234F).",
  },
};

// const result = await checkCompareNames(
//           response?.response?.response?.beneficiaryName ||
//             response?.response?.beneficiaryName,
//           beneficiaryName,
//         );

/* =========================
   MOBILE & PAN COMPONENT
========================= */

function VerifyComponent({ type, onSubmit, onBack }) {
  const [value, setValue] = useState("");
  const [touched, setTouched] = useState(false);
  const [loader, setLoader] = useState(false);
  const [apiError, setApiError] = useState("");

  const config = verificationConfig[type];
  const isValid = config.regex.test(value);

  const handleChange = (e) => {
    let inputValue = e.target.value;

    setApiError("");

    if (type === "Pan") {
      inputValue = inputValue.toUpperCase();
    }
    if (type === "Mobile") {
      inputValue = inputValue.replace(/\D/g, "").slice(0, 10);
    }
    setValue(inputValue);
  };

  const handleVerify = async () => {
    setTouched(true);
    setApiError("");

    // Frontend validation
    if (!isValid) {
      return;
    }
    try {
      setLoader(true);

      // Wait for Mobile/PAN API
      await onSubmit(value);
    } catch (error) {
      console.log("Verification error:", error);

      setApiError(
        error?.message ||
          `${config.label} verification failed. Please try again.`,
      );
    } finally {
      setLoader(false);
    }
  };
  const showError = touched && !isValid;
  return (
    <div className="verification-card">
      {/* {onBack && (
        <button className="back-button" onClick={onBack} disabled={loader}>
          <KeyboardBackspaceIcon fontSize="small" /> Back
        </button>
      )} */}

      <div className="verification-header">
        <div>
          <h2>{config.label} Verification</h2>

          <p>Enter your {config.label.toLowerCase()} to continue.</p>
        </div>
      </div>

      <div className="form-group">
        <label>{config.label}</label>

        <input
          type="text"
          value={value}
          onChange={handleChange}
          onBlur={() => setTouched(true)}
          placeholder={config.placeholder}
          disabled={loader}
          className={`verification-input
            ${showError || apiError ? "input-error" : ""}
            ${isValid && !apiError ? "input-success" : ""}
          `}
        />

        {showError && (
          <p className="error-message">
            {value ? config.errorMessage : `${config.label} is required.`}
          </p>
        )}

        {apiError && <p className="error-message">{apiError}</p>}

        {value && isValid && !apiError && (
          <p className="success-message">✓ Valid {config.label}</p>
        )}
      </div>

      <button
        className="verify-button"
        onClick={handleVerify}
        disabled={loader}
      >
        {loader ? (
          <>
            <span className="spinner"></span>
            Verifying...
          </>
        ) : (
          "Verify & Continue →"
        )}
      </button>
    </div>
  );
}

/* =========================
   BANK COMPONENT
========================= */

function BankVerification({ onBack, beneficiaryName, onSubmit }) {
  const [bankName, setBankName] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const navigate = useNavigate();

  const [confirmAccountNumber, setConfirmAccountNumber] = useState("");

  const [ifscCode, setIfscCode] = useState("");

  const [accountHolderName, setAccountHolderName] = useState("");

  const [errors, setErrors] = useState({});

  const [isVerified, setIsVerified] = useState(false);
  const token = Cookies.get("token");

  /* IFSC Validation */

  const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;

  const validateForm = () => {
    const newErrors = {};

    // if (!bankName) {
    //   newErrors.bankName = "Please select your bank.";
    // }

    if (!accountNumber) {
      newErrors.accountNumber = "Account number is required.";
    } else if (accountNumber.length < 9 || accountNumber.length > 18) {
      newErrors.accountNumber = "Please enter a valid account number.";
    }

    if (!confirmAccountNumber) {
      newErrors.confirmAccountNumber = "Please confirm your account number.";
    } else if (accountNumber !== confirmAccountNumber) {
      newErrors.confirmAccountNumber = "Account numbers do not match.";
    }

    if (!ifscCode) {
      newErrors.ifscCode = "IFSC code is required.";
    } else if (!ifscRegex.test(ifscCode)) {
      newErrors.ifscCode = "Please enter a valid IFSC code.";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  /* Account Verification */

  const handleAccountVerification = async () => {
    if (!validateForm()) return;

    try {
      //   setVerifyLoader(true);

      // Clear previous error
      setErrors((prev) => ({
        ...prev,
        verification: "",
      }));

      const response = await Call_Api(
        path.ACCOUNT_VERIFY,
        "POST",
        {
          account_no: accountNumber,
          ifsc: ifscCode,
        },
        token,
      );

      console.log("Account verification response:", response);

      // API failed
      if (!response?.success) {
        throw new Error(
          response?.message ||
            response?.response?.responseMsg ||
            "Account verification failed.",
        );
      };

      // const CheckCompareName = response?.response?.beneficiaryName !== beneficiaryName;
      const CheckCompareName = await checkCompareNames(response?.response?.beneficiaryName,beneficiaryName);
      
      if (!CheckCompareName) {
        throw new Error(
          "Account verification failed. The account details do not match Pan.",
        );
      }

      const responseData = response?.response;

      // Check invalid account / IFSC
      if (responseData?.message?.toLowerCase() === "invalid") {
        throw new Error(
          "Account Number or IFSC Code is invalid. Please recheck.",
        );
      }

      const userName =
        responseData?.beneficiaryName ||
        responseData?.response?.beneficiaryName;

      // Check beneficiary name
      if (!userName || userName === "Name Not Found") {
        throw new Error(
          responseData?.responseMsg ||
            "Account holder name could not be verified.",
        );
      }

      // SUCCESS

      setAccountHolderName(userName.toUpperCase());

      setIsVerified(true);

      setErrors((prev) => ({
        ...prev,
        verification: "",
      }));
    } catch (error) {
      console.log("Account verification error:", error);

      setIsVerified(false);

      setAccountHolderName("");

      setErrors((prev) => ({
        ...prev,
        verification:
          error?.message || "Account verification failed. Please try again.",
      }));
    }
  };

  const handleSubmit = () => {
    if (!isVerified) {
      setErrors({
        verification: "Please verify your bank account first.",
      });

      return;
    }

    onSubmit({
      bankName,
      accountNumber,
      ifscCode,
      accountHolderName,
    });
  };

  const handleAccountNumberChange = (e) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 18);

    setAccountNumber(value);

    setIsVerified(false);

    setErrors((prev) => ({
      ...prev,
      accountNumber: "",
      verification: ""
    }));
  };

  const handleConfirmAccountChange = (e) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 18);

    setConfirmAccountNumber(value);

    setIsVerified(false);

    setErrors((prev) => ({
      ...prev,
      confirmAccountNumber: "",
      verification:""
    }));
  };

  const handleIfscChange = (e) => {
    const value = e.target.value.toUpperCase().slice(0, 11);

    setIfscCode(value);

    setIsVerified(false);

    setErrors((prev) => ({
      ...prev,
      ifscCode: "",
      verification: ""
    }));
  };

  return (
    <div className="bank-card">
      {/* Back Button */}

      {/* <button className="back-button" onClick={onBack}>
        <KeyboardBackspaceIcon fontSize="small" /> Back
      </button> */}

      <div className="bank-header">
        <h2>Bank Verification</h2>

        <p>Enter your bank account details for verification.</p>
      </div>

      {/* Bank Name */}

      {/* <div className="form-group">
        <label>Bank Name</label>

        <select
          value={bankName}
          onChange={(e) => {
            setBankName(e.target.value);

            setIsVerified(false);

            setErrors((prev) => ({
              ...prev,
              bankName: "",
            }));
          }}
          className={`verification-input ${
            errors.bankName ? "input-error" : ""
          }`}
        >
          <option value="">Select Bank</option>

          <option value="State Bank of India">State Bank of India</option>

          <option value="HDFC Bank">HDFC Bank</option>

          <option value="ICICI Bank">ICICI Bank</option>

          <option value="Axis Bank">Axis Bank</option>

          <option value="Kotak Mahindra Bank">Kotak Mahindra Bank</option>
        </select>

        {errors.bankName && <p className="error-message">{errors.bankName}</p>}
      </div> */}

      {/* Account Number */}

      <div className="form-group">
        <label>Account Number</label>

        <input
          type="text"
          value={accountNumber}
          onChange={handleAccountNumberChange}
          placeholder="Enter Account Number"
          className={`verification-input ${
            errors.accountNumber ? "input-error" : ""
          }`}
        />

        {errors.accountNumber && (
          <p className="error-message">{errors.accountNumber}</p>
        )}
      </div>

      {/* Confirm Account Number */}

      <div className="form-group">
        <label>Confirm Account Number</label>

        <input
          type="text"
          value={confirmAccountNumber}
          onChange={handleConfirmAccountChange}
          placeholder="Confirm Account Number"
          className={`verification-input ${
            errors.confirmAccountNumber ? "input-error" : ""
          }`}
        />

        {errors.confirmAccountNumber && (
          <p className="error-message">{errors.confirmAccountNumber}</p>
        )}
      </div>

      {/* IFSC Code */}

      <div className="form-group">
        <label>IFSC Code</label>

        <input
          type="text"
          value={ifscCode}
          onChange={handleIfscChange}
          placeholder="Enter IFSC Code"
          className={`verification-input ${
            errors.ifscCode ? "input-error" : ""
          }`}
        />

        {errors.ifscCode && <p className="error-message">{errors.ifscCode}</p>}
      </div>

      {/* Account Verification */}

      <div className="account-verification">
        <div>
          <h3>Account Verification</h3>

          <p>Verify your bank account details.</p>
        </div>

        <button
          type="button"
          className="small-verify-button"
          onClick={handleAccountVerification}
        >
          Verify
        </button>
      </div>

      {errors.verification && (
        <p className="error-message">{errors.verification}</p>
      )}

      {/* Account Holder Name */}

      <div className="form-group">
        <label>Name As Per Bank</label>

        <input
          type="text"
          value={accountHolderName || "Auto-filled after verification"}
          disabled
          className="verification-input disabled-input"
        />
      </div>

      {/* Verification Status */}

      {isVerified && (
        <div className="bank-success">✓ Bank account verified successfully</div>
      )}

      {/* Continue */}

      <button
        className="verify-button"
        onClick={handleSubmit}
        disabled={!isVerified}
      >
        Continue →
      </button>
    </div>
  );
}

/* =========================
   MAIN FLOW
========================= */

const AddTutorFlow = () => {
  const [currentFlow, setCurrentFlow] = useState("Mobile");
  const token = Cookies.get("token");
  const navigate = useNavigate();

  const [panBeneficiaryName, setPanBeneficiaryName] = useState("");

  const [verificationData, setVerificationData] = useState({
    mobile: "",
    pan: "",
    bank: {},
  });

  //   const handleMobileSubmit = async (mobile) => {
  //     const response = await Call_Api(
  //       path.MOBILE_VERIFY,
  //       "POST",
  //       {
  //         mobileNumber: mobile,
  //       },
  //       token,
  //     );

  //     if (!response?.success) {
  //       throw new Error(response?.message || "Mobile verification failed.");
  //     }

  //     setVerificationData((prev) => ({
  //       ...prev,
  //       mobile,
  //     }));

  //     setCurrentFlow("Pan");
  //   };

  const handleMobileSubmit = (mobile) => {
    setVerificationData((prev) => ({
      ...prev,
      mobile,
    }));

    setCurrentFlow("Pan");
  };

  const handlePanSubmit = async (pan) => {
    const response = await Call_Api(
      path.PAN_VERIFY,
      "POST",
      { panNumber: pan },
      token,
    );

    if (!response?.success) {
      throw new Error(response?.message || "PAN verification failed.");
    }

    const beneficiaryName =
      response?.response?.response?.beneficiaryName ||
      response?.response?.beneficiaryName ||
      "";

    setPanBeneficiaryName(beneficiaryName);
    console.log("panBeneficiaryName", beneficiaryName);

    setVerificationData((prev) => ({
      ...prev,
      pan,
    }));

    setCurrentFlow("Bank");
  };

  const handleBankSubmit = (bankData) => {
    setVerificationData((prev) => ({
      ...prev,
      bank: bankData,
    }));
    const data = {
      ...bankData,
      pan: verificationData?.pan,
      mobile: verificationData?.mobile,
    };
    navigate("/EducationPay", { state: {cardDetails: data} });
    setCurrentFlow("Completed");
  };

  const handleBack = () => {
    if (currentFlow === "Bank") {
      setCurrentFlow("Pan");
    } else if (currentFlow === "Pan") {
      setCurrentFlow("Mobile");
    } else {
      navigate("/eduSelect");
    }
  };

  return (
    <>
      <Header title="Add Tutor" />
      <div className="add_tutor_container pay_pv_div_s">
        <div className="add_tutor_active_s">
          <div className="add_tutor_top_nav">
            <button
              type="button"
              className="add_tutor_back_btn"
              aria-label="Back"
              onClick={handleBack}
            >
              <KeyboardBackspaceIcon />
            </button>
          </div>
          <div className="verification-container">
            {/* PAGE HEADER */}
            <div className="page-header">
              <h1>Tutor Verification</h1>

              <p>Complete all steps to verify your account.</p>
            </div>

            {/* PROGRESS BAR */}

            <div className="progress-container">
              <div
                className={`step ${
                  currentFlow === "Mobile" ? "active" : "completed"
                }`}
              >
                <span>{currentFlow !== "Mobile" ? "✓" : "1"}</span>
                Mobile
              </div>

              <div
                className={`progress-line ${
                  currentFlow === "Pan" ||
                  currentFlow === "Bank" ||
                  currentFlow === "Completed"
                    ? "completed"
                    : ""
                }`}
              />

              <div
                className={`step ${
                  currentFlow === "Pan"
                    ? "active"
                    : currentFlow === "Bank" || currentFlow === "Completed"
                      ? "completed"
                      : ""
                }`}
              >
                <span>
                  {currentFlow === "Bank" || currentFlow === "Completed"
                    ? "✓"
                    : "2"}
                </span>
                PAN
              </div>

              <div
                className={`progress-line ${
                  currentFlow === "Bank" || currentFlow === "Completed"
                    ? "completed"
                    : ""
                }`}
              />

              <div
                className={`step ${
                  currentFlow === "Bank"
                    ? "active"
                    : currentFlow === "Completed"
                      ? "completed"
                      : ""
                }`}
              >
                <span>{currentFlow === "Completed" ? "✓" : "3"}</span>
                Bank
              </div>
            </div>

            {/* MOBILE */}

            {currentFlow === "Mobile" && (
              <VerifyComponent type="Mobile" onSubmit={handleMobileSubmit} />
            )}

            {/* PAN */}

            {currentFlow === "Pan" && (
              <VerifyComponent
                type="Pan"
                onBack={() => setCurrentFlow("Mobile")}
                onSubmit={handlePanSubmit}
              />
            )}

            {/* BANK */}

            {currentFlow === "Bank" && (
              <BankVerification
                onBack={() => setCurrentFlow("Pan")}
                beneficiaryName={panBeneficiaryName}
                onSubmit={handleBankSubmit}
              />
            )}

            {/* COMPLETED */}

            {/* {currentFlow === "Completed" && <EducationPay cardDetails={verificationData} />} */}
          </div>
        </div>
      </div>
    </>
  );
};

export default AddTutorFlow;
